import { fabric } from 'fabric';
import { getGlobalControlsManager } from './ControlsManager';
import {
  magicFrameChangePersonPhoto,
  magicFrameChangeFramePhoto,
  magicFrameChangeBackgroundPhoto,
  toggleMagicFrameEditMode,
  isMagicFrameInEditing,
  enableFloatingControls,
} from '~core/magicFrame';

export const initMagicFrameFloatingControls = () => {
  const controlsManager = getGlobalControlsManager();

  if (!controlsManager) {
    console.error('ControlsManager not initialized');
    return;
  }

  // Always hide the old controls
  if (fabric.MagicFrame.prototype.controls.replacePhoto) {
    fabric.MagicFrame.prototype.controls.replacePhoto.setVisibility(false);
  }
  if (fabric.MagicFrame.prototype.controls.modifyPhoto) {
    fabric.MagicFrame.prototype.controls.modifyPhoto.setVisibility(false);
  }

  // wrap MagicFrame methods to show/hide floating controls

  fabric.MagicFrame.prototype.showCustomControls = function () {
    let control = controlsManager.getControl(this);
    if (!control) {
      control = controlsManager.createControlsForObject(this);
      if (control) control.show();
    } else {
      control.show();
    }
  };

  fabric.MagicFrame.prototype.hideCustomControls = function () {
    const control = controlsManager.getControl(this);
    if (control) {
      control.hide();
    }
  };

  fabric.MagicFrame.prototype.updateEditMode = function () {
    const control = controlsManager.getControl(this);
    if (control && control.setEditMode) {
      // Use the instance state directly for reliability
      control.setEditMode(!!this.isEditing);
    }
  };

  // Ensure the control label reflects edit mode regardless of how it's toggled
  if (!fabric.MagicFrame.prototype._toggleEditModeWrapped) {
    const originalToggle = fabric.MagicFrame.prototype.toggleEditMode;
    fabric.MagicFrame.prototype.toggleEditMode = function () {
      const res = originalToggle.apply(this, arguments);
      if (typeof this.updateEditMode === 'function') {
        this.updateEditMode();
      }
      return res;
    };
    fabric.MagicFrame.prototype._toggleEditModeWrapped = true;
  }

  const canvas = window.canvas;

  canvas.on('mouse:down', function (e) {
    if (e.target) {
      const mf =
        e.target.type === 'MagicFrame' ? e.target : e.target._magicFrame;
      if (mf) mf.showCustomControls();
    }
  });

  canvas.on('selection:created', function (e) {
    const obj = e.selected && e.selected[0];
    if (!obj) return;
    const mf = obj.type === 'MagicFrame' ? obj : obj._magicFrame;
    if (mf) mf.showCustomControls();
  });

  canvas.on('selection:updated', function (e) {
    const deselected = e.deselected && e.deselected[0];
    if (deselected) {
      const dmf =
        deselected.type === 'MagicFrame' ? deselected : deselected._magicFrame;
      if (dmf) dmf.hideCustomControls();
    }

    const selected = e.selected && e.selected[0];
    if (selected) {
      const smf =
        selected.type === 'MagicFrame' ? selected : selected._magicFrame;
      if (smf) smf.showCustomControls();
    }
  });

  canvas.on('selection:cleared', function (e) {
    const obj = e.deselected && e.deselected[0];
    if (!obj) return;
    const mf = obj.type === 'MagicFrame' ? obj : obj._magicFrame;
    if (mf) mf.hideCustomControls();
  });

  const allObjects = canvas.getObjects();
  allObjects.forEach((obj) => {
    if (obj.type === 'MagicFrame') {
      const control = controlsManager.createControlsForObject(obj);
      if (control) control.hide();
    }
  });

  console.log('Magic Frame floating controls initialized');
};

export const replaceMagicFrameControls = () => {
  // Enable floating controls mode
  enableFloatingControls();

  // Store original functions globally for compatibility
  window.magicFrameChangePersonPhoto = magicFrameChangePersonPhoto;
  window.magicFrameChangeFramePhoto = magicFrameChangeFramePhoto;
  window.magicFrameChangeBackgroundPhoto = magicFrameChangeBackgroundPhoto;
  window.toggleMagicFrameEditMode = toggleMagicFrameEditMode;
  window.isMagicFrameInEditing = isMagicFrameInEditing;

  // Initialize the floating controls
  initMagicFrameFloatingControls();
};
